/* tslint:disable */
/* eslint-disable */
export enum WorkAccountSelectionModeEnum {
  ExpenseClasses = 'expense_classes',
  All = 'all',
  Manual = 'manual'
}
